module.exports = __webpack_public_path__ + "img/pic_uk_07.5184d4a2.jpg";